import _ from 'underscore';
import CoreModel from 'core/models/core';


// Container for static properties
var Question = {};

// Create underscore templates for all question types on the page, once
_.each($('.question-type-template'), function (questionTemplate) {
  var $template = $(questionTemplate);
  Question[$template.attr('id')] = _.template($template.html());
});

// Question model
export default CoreModel.extend({
  urlRoot: QUESTION_API_URL,

  initialize: function () {
    this.template = Question[this.get('question_type') + '-template'];
    this.long_index = [ 'zero', 'one', 'two', 'three', 'four', 'five',
      'six', 'seven', 'eight', 'nine', 'ten' ];

  },

  is_likert: function () {
    return this.get('question_type') == 'radio-likert';
  },

  is_likert_start: function (prev_question) {
    // Given the previous question (or null), determine whether or not
    // this question is the start of a likert sequence

    if (!this.is_likert()) {
      // If the question is not a likert question, then it is not the
      // start of a likert sequence
      return false;
    } else if (prev_question === null) {
      // The question is a likert question, and there are no questions
      // before it, therefore it is the start of the sequence.
      return true;
    } else if (!prev_question.is_likert()) {
      // The previous question is not a likert, therefore this
      // question is the start of the sequence
      return true;
    } else if (prev_question.get('option_set').id !== this.get('option_set').id) {
      // If the prev question uses a different set of options, then
      // we are at the start of the sequence.
      return true;
    } else if (prev_question.get('sequence') + 1 !== this.get('sequence')) {
      // The previous question IS a likert, but the difference
      // between sequences is > 1, so this question starts a new
      // sequence
      return true;
    }

    // In all other circumstances, the proper return value is false
    return false;
  },

  is_likert_end: function (next_question) {
    // Given the next question (or null), determine whether or not
    // this question is the end of a likert sequence

    if (!this.is_likert()) {
      // If the question is not a likert question, then it is not the
      // end of a likert sequence
      return false;
    } else if (next_question === null) {
      // The question is a likert question, and there are no questions
      // after it, therefore it is the end of the sequence.
      return true;
    } else if (!next_question.is_likert()) {
      // The next question is not a likert, therefore this
      // question is the end of the sequence
      return true;
    } else if (this.get('option_set').id !== next_question.get('option_set').id) {
      // If the next question uses a different set of options, then
      // we are at the end of the sequence.
      return true;
    } else if (this.get('sequence') + 1 !== next_question.get('sequence')) {
      // The next question IS a likert, but the difference
      // between sequences is > 1, so this question starts a new
      // sequence
      return true;
    }

    // In all other circumstances, the proper return value is false
    return false;
  }
}, Question);



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/models/question.js
// module id = 162
// module chunks = 0